// extracted by mini-css-extract-plugin
export default {"Faq":"Faq_Faq__tkoio","Summary":"Faq_Summary__Ui9EQ","Toggle":"Faq_Toggle__OMPQz","Detail":"Faq_Detail__4JBsR","Expanded":"Faq_Expanded__oKYtC"};